(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    

$(function () {
  $(".drop-down-menu ul").css("display", "none");
  $(".drop-down-menu .h6").click(function () {
    $(this).toggleClass("open").next().slideToggle(300);
  });
});

  } catch(e) { console.error(e); }
})();
})();
